export default __webpack_public_path__ + "static/media/heat-map.1f364a88.svg";